<script>
  import { csv } from 'd3-fetch';
  import { t,__, __c } from '../../../utils/i18n';
  import { police } from '../../../utils/copy';

  export let inc; //True if actual city
  export let city; // just name of the place

  const lang = document.documentElement.lang;

  ////////////////////////
  // police card lookup //
  ////////////////////////

  // const policeDataURL = new URL('../../../../_data/police.csv', import.meta.url);
  const policeDataURL = window.DATA_URLS.police

  // see if the city is in the spreadsheet
  async function policeCityLookup(c) {
    const policeData = await csv(policeDataURL);
    let found = policeData.find((item) => String(item.city) == String(c));
    return Object(found);
  }

  $: policeDPT = policeCityLookup(city);

  // let isException = cityServices[lang]['Exceptions'][d.id] ? true : false;
  // console.log('POLICE', policeDPT);

 </script>
{#if inc}
    {#await policeDPT}
    <p></p>
    {:then p}
      {#if p.dept_name}
        <!-- if the city name is in the csv -->
        <p>
          <!-- The {p.dept_name} is your law enforcement agency. Here’s how to reach them:
          by phone - <a href="tel:+1{p.dept_phone}">{p.dept_phone}</a> (for non-emergencies) and <a target="_blank" rel="external" href="{p.dept_weblink}">online</a>. -->
          {@html t(police, 'cityDept', {
            'p.dept_name': p.dept_name,
            'p.dept_phone': p.dept_phone,
            'p.dept_weblink': p.dept_weblink,
          })}
          
        </p>
        <!-- complaints -->
        <p class="subhed"><span class="label">{__("Give input")}</span></p>
        <p>
          <!-- If you experienced or witnessed something involving the conduct of law
          enforcement officers you want to file a complaint or commendation
          about, your department accepts submissions {p.comment_method}
          Your department’s complaint form  -->
          {@html t(police, 'giveInput', {
            'p.comment_method': p[__c("comment_method")],
          })}
          {#if p.form_online == "TRUE"}
            <!-- is available <a href="{p.comment_link}" rel="external" target="_blank">here.</a> -->
            {@html t(police, 'formOnline', {
              'p.comment_link': p.comment_link,
            })}
          {:else}
            <!-- is available to be picked up in person. -->
            { t(police, 'formPhysical', '') }
          {/if}</p>
        <p class="subhed"><span class="label">{__("Get involved")}</span></p>
        <p>
          <!-- If you want to get involved in how your police department is run, you
          can join with existing activist groups to work on issues you care
          about. Attending city council meetings is one way to get started and
          meet other engaged residents. -->
          { t(police, 'getInvolved', '') }
        </p>

        {#if p.oversight=="TRUE"}
        <p>
          <!-- You can also attend a public meeting of the {p.oversight_name}, which {p.oversight_duty} and fields public feedback. You can make a public comment! Find out more at the {p.oversight_name}{#if p.oversight_name.charAt(p.oversight_name.length - 1)=="s"}&rsquo;{:else}&rsquo;s{/if} <a target="_blank" rel="external" href="{p.oversight_weblink}">website</a>. -->
          {@html t(police, 'oversight', {
            'p.oversight_name': p.oversight_name,
            'p.oversight_duty': p[__c("oversight_duty")],
            'p.oversight_name_possessive': p.oversight_name.charAt(p.oversight_name.length - 1)=="s" ? `${p.oversight_name}&rsquo;` : `${p.oversight_name}&rsquo;s`,
            'p.oversight_weblink': p.oversight_weblink,
          })}
        </p>
 
        {/if}
      {:else}
        <!-- a city but no department -->
        <p>
          <!-- Your city does not have its own police department. Instead, it
          contracts with the Los Angeles County Sheriff’s Department for most
          law enforcement services in your city. -->
          { t(police, 'cityNoDept', '') }
        </p>
        <p>
          <!-- If you want to get involved in how the Sheriff’s Department is run,
          you can join existing activist groups that work on the issues you care
          about. You can also attend and speak at the public meetings of the Los
          Angeles County Civilian Oversight Commission, which was established in
          2016 in an effort to bring more transparency to the Sheriff’s
          Department. Find out more 
          <a class="link"
          rel="external"
              href="https://coc.lacounty.gov/"
              target="_blank">here</a>. -->
          {@html t(police, 'sheriffDept', '') }
        </p>
      {/if}
    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
{:else}
    <!-- a unincorporated -->
    <p>
      <!-- Because you live in an unincorporated area, the Los Angeles County Sheriff’s Department is your law enforcement
      agency. -->
      { t(police, 'unincorporated', '') }
    </p>
    <p>
      <!-- If you want to get involved in how the Sheriff’s Department is run, you
      can join existing activist groups that work on the issues you care about.
      You can also attend and speak at the public meetings of the Los Angeles
      County Civilian Oversight Commission, which was established in 2016 in an
      effort to bring more transparency to the Sheriff’s Department. Find out
      more <a class="link" href="https://coc.lacounty.gov/" rel="external" target="_blank">here</a>. -->
      {@html t(police, 'sheriffDept', '') }
    </p>

{/if}
